import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Ortak } from './../../../../providers/ortak';
import { BankaEkleGuncellePage } from './../../../Yonetim/BankaIslemleri/banka-ekle-guncelle/banka-ekle-guncelle';
import { Component } from '@angular/core';
import {  NavController, NavParams, ModalController, ActionSheetController } from 'ionic-angular';
import { BankaHareketPage } from '../banka-hareket/banka-hareket';

/**
 * Generated class for the BankListePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-bank-liste',
  templateUrl: 'bank-liste.html',
})
export class BankListePage {
  aranan="";
  skip:number=0;
  take:number=50;
  BankaListesi=[];

  constructor(public navCtrl: NavController,
    public ortak:Ortak,
    public bllOrtak:BllOrtak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BankaListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.BankaListesi = sonuc.SonucObject;
     
   
 
    })
  }
  
  bankakayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(BankaEkleGuncellePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  Bankaduzenle(banka){
    let modal = this.modalCtrl.create(BankaEkleGuncellePage, { BankaVw: banka });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  
  }
  BankaSil(banka) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("Banka_json", banka.ID);
     

      this.bllOrtak.islem(formData, "BankaSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }
  BankayaYatan(banka){
    let modal=this.modalCtrl.create(BankaHareketPage,{BankaVw:banka});
    modal.onDidDismiss(data=>{
      this.ionViewDidLoad();
    })
    modal.present();

  }
  Islemler(banka) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Banka  İşlemleri',
      buttons: [
        {
          text: 'Banka-ya Yatan',
  
          handler:()=>{
        this.BankayaYatan(banka);
          }
         
        },
        {
          text: 'Bankadan Çekilen',
  
          handler:()=>{
          this.BankayaYatan(banka);
          }
         
        },
        {
          text: 'Havale İşlemi',
  
          handler:()=>{
          this.BankayaYatan(banka);
          }
         
        },
        {
          text: 'Eft İşlemi',
  
          handler:()=>{
          this.BankayaYatan(banka);
          }
         
        },
        {
          text: 'Bankalar Arası Virman',
  
          handler:()=>{
            this.BankayaYatan(banka);
          }
         
        },{
          text: 'Düzenle',
          handler: () => {
           this.Bankaduzenle(banka);
          }
        },{
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/Yonetim/BankaIslemleri/bank-liste/bank-liste.ts